import AssetField from '../../../contentful/AssetField';
import cookie from 'js-cookie';
import DatePicker, {registerLocale} from 'react-datepicker';
import dpLocale from 'date-fns/locale/nb';
import DealerEmployee from './DealerEmployee';
import DealerMake from './DealerMake';
import makeImageTransformer from '../../../../model/transformers/makeImage';
import EntityCollectionField from '../../../contentful/EntityCollectionField';
import AssetCollectionField from '../../../contentful/AssetCollectionField';
import {NavLink as Link} from 'react-router-dom';
import BlockEditor from '../../../block-editor/Editor';
import PublishStatusDot from '../../../misc/PublishStatusDot.js';
import update from 'immutability-helper';
import React from 'react';
import TagsInput from 'react-tagsinput';
import CustomVariables from '../misc/CustomVariables.js';
// import {Panel, PanelGroup} from 'react-bootstrap';
// import TinyMCE from 'react-tinymce';
// import marked from 'marked';
// import toMarkdown from 'to-markdown';

import 'react-tagsinput/react-tagsinput.css';
import 'react-datepicker/dist/react-datepicker.css';
import {OverlayTrigger} from 'react-bootstrap';
import {createTooltip} from '../../../misc/utils';

registerLocale('nb', dpLocale);

class Dealer extends React.Component {
  constructor(props) {
    super(props);

    this.handleAssetChange = this.handleAssetChange.bind(this);
    this.handleDeviationActive = this.handleDeviationActive.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleSave = this.handleSave.bind(this);
    this.handlePublish = this.handlePublish.bind(this);
    this.handleUnpublish = this.handleUnpublish.bind(this);
    this.handleFieldChange = this.handleFieldChange.bind(this);
    // this.handleDateChange = this.handleDateChange.bind(this);
    this.updateDealerState = this.updateDealerState.bind(this);
    this.setTabCookie = this.setTabCookie.bind(this);
    this.openingHoursDefaultText = this.openingHoursDefaultText.bind(this);
    this.handleGroupTagsChange = this.handleGroupTagsChange.bind(this);
    this.handleGroupTagClick = this.handleGroupTagClick.bind(this);
    this.updateLookupString = this.updateLookupString.bind(this);
    this.handleMakeImageChange = this.handleMakeImageChange.bind(this);

    this.state = {
      dealerMapLookupString: null
    };
  }

  updateLookupString() {
    let dealerMapLookupString = `${this.props.dealer.address} ${this.props.dealer.zipcode} ${this.props.dealer.ziparea}, Norway`;
    if (this.props.dealer.useNameInMapLookup) {
      dealerMapLookupString = `${this.props.dealer.name} ${dealerMapLookupString}`;
    }

    this.setState({
      dealerMapLookupString: dealerMapLookupString
    });
  }

  componentDidMount() {
    const tab = cookie.get('mgDealerTab');
    if (tab !== '' && tab !== undefined && document.getElementById(tab)) {
      const tabLink = document.getElementById(tab);
      tabLink.click();
    }
  }

  handleSubmit(e) {
    e.preventDefault();
    this.props.onSave();
  }

  handlePublish(e) {
    e.preventDefault();
    this.props.onPublish();
  }

  handleUnpublish(e) {
    e.preventDefault();
    this.props.onUnpublish();
  }

  handleSave(e) {
    e.preventDefault();
    this.props.onSave();
  }

  handleAssetChange(name, asset) {
    const change = {
      dealer: {}
    };

    change.dealer[name] = {
      $set: asset
    };

    const props = update(this.props, change);

    this.props.onChange(props);
  }

  handleMakeImageChange(makeName, asset) {
    const existingMakeImages = this.props.dealer.makeImages ?? [];

    // Filter out the existing other items.
    const filteredMakeImages = existingMakeImages.filter((makeImage) => makeImage.make !== makeName);

    // Check if we have an existing make image wrapper for the given make.
    const existingWrapper = existingMakeImages.find((makeImage) => makeImage.make === makeName);
    if (existingWrapper) {
      // Make sure there actually is an asset. If there is no asset, it means
      // the user has removed the image and want to delete the make image.
      // In that case we do not nothing as we have already filtered it out earlier.
      if (asset) {
        existingWrapper.image = asset;

        filteredMakeImages.push(existingWrapper);
      }
    } else {
      // If we dont, create a new wrapper with the new asset link and make name.
      const newMakeImage = makeImageTransformer.make(makeName, asset);

      // Add it to the makeImages array.
      filteredMakeImages.push(newMakeImage);
    }

    const change = {
      dealer: {}
    };

    change.dealer.makeImages = {
      $set: filteredMakeImages
    };

    const props = update(this.props, change);

    this.props.onChange(props);
  }

  handleFieldChange(e) {
    const newData = {
      dealer: {}
    };

    if (e.target.type === 'checkbox') {
      newData.dealer[e.target.name] = {
        $set: e.target.checked
      };
    } else {
      newData.dealer[e.target.name] = {
        $set: e.target.value
      };
    }

    const props = update(this.props, newData);

    this.props.onChange(props);
  }

  handleDateChange(date, inputName) {
    // TODO: https://github.com/Hacker0x01/react-datepicker/issues/1018
    // Fix issue with date being a day off by setting hour to after midnight,
    // we only use the date anyway.
    // Note: Only seems to be an issue where the field is set to "Date only" in contentful :S
    if (date) {
      date.setHours(2);
    }

    const elem = {
      target: {
        name: inputName,
        value: date
      }
    };

    this.handleFieldChange(elem);
  }

  handleDeviationActive(e) {
    const dateFieldFrom = document.getElementById('openingHoursDeviationFromdate');
    const dateFieldTo = document.getElementById('openingHoursDeviationTodate');

    dateFieldFrom.disabled = !e.target.checked;
    dateFieldTo.disabled = !e.target.checked;
    this.handleFieldChange(e);
  }

  handleGroupTagsChange(tagsArray, changed) {
    const newData = {
      dealer: {}
    };

    // Prevent duplicates on add by checking if its first index is at the end (the newly added one)
    if (tagsArray.includes(changed[0]) && tagsArray.indexOf(changed[0]) !== (tagsArray.length - 1)) {
      return;
    }

    newData.dealer.groupTags = {
      $set: tagsArray
    };

    const props = update(this.props, newData);
    this.props.onChange(props);
  }

  handleGroupTagClick(e, tag) {
    e.preventDefault();

    const newData = {
      dealer: {}
    };

    const tagsArray = this.props.dealer.groupTags;

    if (tagsArray.includes(tag)) {
      return;
    }

    tagsArray.push(tag);

    newData.dealer.groupTags = {
      $set: tagsArray
    };

    const props = update(this.props, newData);
    this.props.onChange(props);
  }

  updateDealerState(newDealer) {
    this.props.updateDealerState(newDealer);
  }

  setTabCookie(e) {
    const tabLink = e.target.id;
    const cookieName = 'mgDealerTab';

    cookie.set(cookieName, tabLink, {path: '/'});
  }

  openingHoursDefaultText() {
    // Return default text here
    return null;
  }

  render() {
    if (this.props.dealer) {
      const dealer = this.props.dealer;

      // Handle opening hours deviation checkbox and textfields
      let openinghours = null;
      let openinghoursDeviation = null;

      let openinghoursDeviationActive = false;
      if (dealer.openinghoursDeviationActive === true) {
        openinghoursDeviationActive = true;
      }
      if (dealer.openinghours) {
        openinghours = dealer.openinghours;
      } else {
        openinghours = this.openingHoursDefaultText();
      }
      if (dealer.openinghoursDeviation) {
        openinghoursDeviation = dealer.openinghoursDeviation;
      }

      // handle all available makes-list
      let allMakes = [];
      if (this.props.allMakes) {
        allMakes = this.props.allMakes;
      }

      // Employees
      let employeeList = 'Ingen ansatte registrert for forhandler';
      if (this.props.employees.length > 0) {
        const employeesArray = this.props.employees;
        employeesArray.sort(function (a, b) {
          const nameA = a.name.toUpperCase(); // ignore upper and lowercase
          const nameB = b.name.toUpperCase(); // ignore upper and lowercase
          if (nameA < nameB) {
            return -1;
          }
          if (nameA > nameB) {
            return 1;
          }

          // names must be equal
          return 0;
        });
        employeeList = (
          <div className="dealerEmployees row">
            {employeesArray.map((employee, i) => {
              return (
                <div key={i} className="col-xs-12 col-md-6">
                  <DealerEmployee employee={employee} makes={allMakes} />
                </div>
              );
            })}
          </div>
        );
      }

      // handle makes-list
      let makes = [];
      if (this.props.models) {
        makes = this.props.models;
      }

      // Build array of current make names for use in GA-code handling
      // We show only GA-code-fields for makes currently connected to dealer.
      const makeNames = dealer.makes.map((make) => {
        if (make.name) {
          return make.name.toLowerCase();
        } else if (make.title) {
          return make.title.toLowerCase();
        }
      });

      const entityFilter = 'bilmerker';

      const predefinedTags = ['Forhandler'];
      if (dealer.name !== '') {
        predefinedTags.push(dealer.name);
      }

      return (
        <section className="dealer mf-padding-top-20">
          {/* <h1><button className="btn btn-sm btn-default" onClick={browserHistory.goBack}><i className="fa fa-chevron-left"></i> Tilbake til forhandlere</button></h1>*/}
          <ol className="breadcrumb">
            <li><Link to="/">Forsiden</Link></li>
            <li><Link to="/forhandlere/">Forhandlere</Link></li>
            <li className="active">{dealer.name}</li>
          </ol>

          <form onSubmit={this.handleSubmit}>
            <div className="page-header">
              <div className="pull-right">
                {this.props.working &&
                  <span><i className="fa fa-spinner fa-pulse fa-fw"></i> Arbeider...&nbsp;</span>
                }
                <button
                  type="submit"
                  className="btn btn-default"
                  disabled={!this.props.modified || this.props.working}
                >
                  <span>Lagre endringer</span>
                </button>
                &nbsp;
                <button
                  type="button"
                  className="btn btn-success"
                  disabled={(dealer.published && !dealer.updated) || this.props.working || this.props.modified}
                  onClick={this.handlePublish}
                >
                  <span>Publiser</span>
                </button>
                &nbsp;
                <button
                  type="button"
                  className="btn btn-warning"
                  disabled={dealer.draft || this.props.working}
                  onClick={this.handleUnpublish}
                >
                  <span>Avpubliser</span>
                </button>
              </div>
              <h1>
                {dealer.name} <PublishStatusDot entry={dealer} /><br />
                <small>Forhandler</small>
              </h1>
            </div>

            {/* Display any error message: */}
            {this.props.error &&
              <div className="alert alert-danger">
                {this.props.error}
              </div>
            }

            {this.props.dealerCheck && this.props.dealerCheck.employees === 0 &&
              <div className="alert alert-warning">
                <strong>Fant ingen ansatte på denne forhandleren i AD.</strong>
                <br/>
                Om forhandleren ikke heter &quot;{dealer.firmSyncName || dealer.name}&quot; i AD kan du endre dette under &quot;AD-navn&quot; på fanen &quot;Innstillinger&quot;.
              </div>
            }

            {/* Main content in tabs*/}
            {/* Tabs */}
            <ul className="nav nav-tabs" role="tablist">
              <li role="presentation" className="active">
                <a id="generalTab" data-target="#general" href="#general" aria-controls="general" role="tab" data-toggle="tab" onClick={this.setTabCookie}>Generelt</a>
              </li>
              <li role="presentation">
                <a id="imagesTab" data-target="#images" href="#images" aria-controls="images" role="tab" data-toggle="tab" onClick={this.setTabCookie}>Bilder</a>
              </li>
              <li role="presentation">
                <a id="openinghoursTab" data-target="#openinghours" href="#openinghours" aria-controls="openinghours" role="tab" data-toggle="tab" onClick={this.setTabCookie}>Åpningstider</a>
              </li>
              <li role="presentation">
                <a id="aboutTab" data-target="#about" href="#about" aria-controls="about" role="tab" data-toggle="tab" onClick={this.setTabCookie}>Om oss</a>
              </li>
              <li role="presentation">
                <a id="employeesTab" data-target="#employees" href="#employees" aria-controls="employees" role="tab" data-toggle="tab" onClick={this.setTabCookie}>Ansatte</a>
              </li>
              <li role="presentation">
                <a id="carsTab" data-target="#cars" href="#cars" aria-controls="cars" role="tab" data-toggle="tab" onClick={this.setTabCookie}>Merker og modeller</a>
              </li>
              <li role="presentation">
                <a id="deliveryTab" data-target="#delivery" href="#delivery" aria-controls="delivery" role="tab" data-toggle="tab" onClick={this.setTabCookie}>Leveringstid</a>
              </li>
              <li role="presentation">
                <a id="settingsTab" data-target="#settings" href="#settings" aria-controls="settings" role="tab" data-toggle="tab" onClick={this.setTabCookie}>Innstillinger</a>
              </li>
              <li role="presentation">
                <a id="consultingTab" data-target="#consulting" href="#consulting" aria-controls="consulting" role="tab" data-toggle="tab" onClick={this.setTabCookie}>Digital konsultasjon</a>
              </li>
            </ul>

            {/* Tab content */}
            <div className="tab-content mf-margin-bottom-40">

              {/* // GENERAL */}
              <div role="tabpanel" className="tab-pane active" id="general">
                <div className="row">
                  <div className="col-xs-12 col-md-6">
                    <div className="form-group">
                      <label>Navn</label>
                      <input type="text" className="form-control" name="name" defaultValue={dealer.name} disabled={this.props.working} onChange={this.handleFieldChange} />
                    </div>
                    <div className="checkbox">
                      <label>
                        <input type="checkbox" name="useNameInMapLookup" defaultChecked={dealer.useNameInMapLookup} disabled={this.props.working} onChange={this.handleFieldChange} />
                        Bruk forhandlernavn i kartoppslag
                      </label>
                      <span id="helpBlock" className="help-block">Øker treffsikkerheten i adresseoppslag dersom forhandleren er registrert i Google.</span>
                    </div>
                    <div className="form-group">
                      <label>Kort navn</label>
                      <input type="text" className="form-control" name="shortname" defaultValue={dealer.shortname} disabled={this.props.working} onChange={this.handleFieldChange} />
                      <span className="help-block">Kort navn brukes primært i lokasjonsvelger, for forhandlere som er gruppert. Ikke påkrevet.</span>
                    </div>
                    <div className="form-group">
                      <label>Telefon</label>
                      <input type="text" className="form-control" name="phone" defaultValue={dealer.phone} disabled={this.props.working} onChange={this.handleFieldChange} />
                    </div>
                    <div className="form-group">
                      <label>Egen nettside</label>
                      <div className="input-group">
                        <div className="input-group-addon">http://</div>
                        <input type="text" className="form-control" name="url" defaultValue={dealer.websiteUrl} disabled={this.props.working} onChange={this.handleFieldChange} />
                      </div>
                    </div>
                    <div className="form-group">
                      <label>Adresse</label>
                      <input type="text" className="form-control" name="address" defaultValue={dealer.address} disabled={this.props.working} onChange={this.handleFieldChange} />
                    </div>
                    <div className="form-group">
                      <div className="row">
                        <div className="col-xs-4">
                          <input type="text" className="form-control" name="zipcode" defaultValue={dealer.zipcode} disabled={this.props.working} onChange={this.handleFieldChange} />
                        </div>
                        <div className="col-xs-8">
                          <input type="text" className="form-control" name="ziparea" defaultValue={dealer.ziparea} disabled={this.props.working} onChange={this.handleFieldChange} />
                        </div>
                      </div>
                    </div>
                    <div className="form-group">
                      <label>GPS</label>
                      <div className="row">
                        <div className="col-xs-5">
                          <div className="input-group">
                            <div className="input-group-addon">LAT</div>
                            <input type="text" className="form-control" name="gpsLocationLat" defaultValue={dealer.gpsLocation.lat} disabled={this.props.working} onChange={this.handleFieldChange} />
                          </div>
                        </div>
                        <div className="col-xs-5">
                          <div className="input-group">
                            <div className="input-group-addon">LON</div>
                            <input type="text" className="form-control" name="gpsLocationLon" defaultValue={dealer.gpsLocation.lon} disabled={this.props.working} onChange={this.handleFieldChange} />
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="col-xs-12 col-md-6">
                    <div className="form-group">
                      <label>Kartoppslag <small>(<a onClick={this.updateLookupString} role="button">{this.state.dealerMapLookupString ? 'Oppdater kart' : 'Test kartoppslag'}</a>)</small></label>
                      <span id="helpBlock" className="help-block">{this.state.dealerMapLookupString}</span>
                      {this.state.dealerMapLookupString &&
                        <iframe width="100%" height="450px" frameBorder="0" scrolling="no" marginHeight="0" marginWidth="0" src={`https://maps.google.com/maps/embed/v1/place?key=AIzaSyAgS98aBA5ehQ1IOYjBmk9K38mNsNbszXI&q=${encodeURIComponent(this.state.dealerMapLookupString)}&zoom=16`}></iframe>
                      }
                    </div>
                  </div>
                </div>
              </div>
              {/* // GENERAL */}

              {/* IMAGES */}
              <div role="tabpanel" className="tab-pane" id="images">
                <div className="row">
                  <div className="col-xs-12 col-md-6">
                    <div className="form-group">
                      <label>Hovedbilde</label>
                      <AssetField name="image" value={dealer.image} onChange={this.handleAssetChange} disabled={this.props.working} predefinedTags={predefinedTags} />
                    </div>
                  </div>

                  <div className="col-xs-12 col-md-6">
                    <div className="form-group">
                      <label>Logo</label>
                      <AssetField name="logo" value={dealer.logo} onChange={this.handleAssetChange} disabled={this.props.working} predefinedTags={predefinedTags} />
                    </div>
                  </div>
                </div>
                <div className="row">
                  <div className="col-xs-12 col-md-6">
                    <div className="form-group">
                      <label>Logo for svart bakgrunn</label>
                      <AssetField name="logoBright" value={dealer.logoBright} onChange={this.handleAssetChange} disabled={this.props.working} predefinedTags={predefinedTags} />
                    </div>
                  </div>
                </div>
                {dealer.makes.length > 0 && (
                  <>
                    <>
                      <h4>
                        Merkebilder
                        &nbsp;
                        <OverlayTrigger placement="top" overlay={createTooltip('Hvis merkebilde er satt for et gitt merke, så vil det erstatte hovedbildet')}>
                          <span className="fa fa-question text-info" aria-hidden="true"></span>
                        </OverlayTrigger>
                      </h4>
                    </>
                    <div className="row">
                      {dealer.makes.map((make) => {
                        const makeImage = dealer.makeImages.find((makeImage) => makeImage.make === make.slug) || {};

                        return (
                          <div key={make.id} className="col-xs-12 col-md-6">
                            <label>{make.name}</label>
                            <AssetField
                              name={make.slug}
                              value={makeImage.image}
                              onChange={this.handleMakeImageChange}
                              disabled={this.props.working}
                              predefinedTags={[...predefinedTags, make.name]}
                            />
                          </div>
                        );
                      })}
                    </div>
                  </>
                )}
              </div>
              {/* IMAGES */}

              {/* PRICES */}
              <div role="tabpanel" className="tab-pane" id="price">
                <div className="row">
                  <div className="col-xs-12 col-md-6">

                  </div>
                </div>
                <div className="clearfix"></div>
              </div>
              {/* // PRICES */}

              {/* OPENING HOURS */}
              <div role="tabpanel" className="tab-pane" id="openinghours">
                <div className="row">
                  <div className="col-xs-12 col-sm-6">
                    <div className="form-group">
                      <label>Standardtider</label>
                      <textarea className="form-control" name="openinghours" rows="20" defaultValue={openinghours} disabled={this.props.working} onChange={this.handleFieldChange} />
                    </div>
                  </div>
                  <div className="col-xs-12 col-sm-6">
                    <div className="form-group">
                      <label>Avvikstider</label>
                      <div className="form-group">
                        <label>Tittel</label>
                        <input type="text" className="form-control" name="openinghoursDeviationTitle" defaultValue={dealer.openinghoursDeviationTitle} disabled={this.props.working} onChange={this.handleFieldChange} />
                      </div>
                      <textarea className="form-control" name="openinghoursDeviation" rows="20" defaultValue={openinghoursDeviation} disabled={this.props.working} onChange={this.handleFieldChange} />
                    </div>

                    <div className="form-group">
                      <label>Disclaimer</label>
                      <input type="text" className="form-control" name="openinghoursDeviationDisclaimer" defaultValue={dealer.openinghoursDeviationDisclaimer} disabled={this.props.working} onChange={this.handleFieldChange} />
                    </div>

                    <div className="checkbox">
                      <label>
                        <input type="checkbox" name="openinghoursDeviationActive" defaultChecked={openinghoursDeviationActive} disabled={this.props.working} onChange={this.handleDeviationActive} />
                        Avvikstider aktiv
                      </label>
                      <span id="helpBlock" className="help-block">Sett hake her dersom avvikstidene skal vises på nettsiden, i stedet for standardtidene.</span>
                    </div>

                    <div className="form-group">
                      <label>Gjelder f.o.m. - t.o.m.</label>
                      <div>
                        <DatePicker
                          name="openingHoursDeviationFromdate"
                          id="openingHoursDeviationFromdate"
                          disabled={this.props.working || !openinghoursDeviationActive}
                          className="form-control"
                          locale="nb"
                          dateFormat="dd.MM.yyyy"
                          selected={dealer.openingHoursDeviationFromdate}
                          onChange={(e) => this.handleDateChange(e, 'openingHoursDeviationFromdate')}
                        />&nbsp;&ndash;&nbsp;
                        <DatePicker
                          name="openingHoursDeviationTodate"
                          id="openingHoursDeviationTodate"
                          disabled={this.props.working || !openinghoursDeviationActive}
                          className="form-control"
                          locale="nb"
                          dateFormat="dd.MM.yyyy"
                          selected={dealer.openingHoursDeviationTodate}
                          onChange={(e) => this.handleDateChange(e, 'openingHoursDeviationTodate')}
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              {/* // OPENING HOURS */}

              {/* ABOUT */}
              <div role="tabpanel" className="tab-pane" id="about">
                <div className="row">
                  <div className="col-xs-12 col-md-6">
                    <div className="form-group">
                      <label>Om oss <em className="small text-muted">(Påkrevet)</em></label>
                      <BlockEditor
                        blocks={dealer.about}
                        onChange={(blocks) => this.handleAssetChange('about', blocks)}
                        disabled={this.props.working}
                        predefinedTags={predefinedTags}
                        allowVideo
                      />
                    </div>
                  </div>
                  <div className="col-xs-12 col-md-6">
                    <div className="form-group">
                      <label>Bildegalleri (Brukes på Motorforum)</label>
                      <AssetCollectionField
                        name="slideshow"
                        value={dealer.slideshow}
                        onChange={this.handleAssetChange}
                        disabled={this.props.working}
                        predefinedTags={predefinedTags}
                      />
                    </div>
                  </div>
                </div>
              </div>
              {/* // ABOUT */}

              {/* EMPLOYEES */}
              <div role="tabpanel" className="tab-pane" id="employees">
                {/*<div className="mf-margin-bottom-20 text-right">
                  <Link
                    to={`/ansatt/new/${dealer.id}`}
                    className="btn btn-success"
                    disabled={this.props.working}
                  >
                    Ny ansatt
                  </Link>
                </div>*/}
                {employeeList}
                {dealer.crossEmployees.length > 0 && <div className="mf-margin-top-20">
                  <h3>Kryssansatte (intern kobling)</h3>
                  {dealer.crossEmployees.map((e) => {
                    return <h4 key={e.sys.id}>{e.fields.name['nb-NO']} ({e.fields.dealer['nb-NO'].fields.name['nb-NO']}) <Link to={`/ansatt/${e.sys.id}`} className="btn btn-default">Rediger</Link></h4>;
                  })}
                </div>}
              </div>
              {/* // EMPLOYEES */}

              {/* CARS */}
              <div role="tabpanel" className="tab-pane" id="cars">
                <div className="row">
                  <div className="col-xs-12">
                    <h3>Merker som føres av forhandler</h3>
                    <EntityCollectionField
                      name="makes"
                      value={dealer.makes}
                      contentType={entityFilter}
                      onChange={this.handleAssetChange}
                      disabled={this.props.working}
                    />
                  </div>
                </div>

                <div className="row">
                  <div className="col-xs-12 col-md-6">
                    <div className="form-group">
                      <label><h3>Justering fraktpåslag</h3></label>
                      <div className="input-group">
                        <div className="input-group-addon">NOK</div>
                        <input type="text" className="form-control" name="priceadjustment" defaultValue={dealer.priceadjustment} disabled={this.props.working} onChange={this.handleFieldChange} />
                        <div className="input-group-addon">,-</div>
                      </div>
                      <span className="help-block">Vil gjelde alle modeller. Juster pr. modell under ved behov. Pris inkl. mva</span>
                    </div>
                  </div>
                </div>

                <div className="row">
                  <div id="dealerMakes" className="dealerMakes">
                    {makes.map((make, i) => {
                      return (
                        <div className="col-xs-12 col-md-6" key={i}>
                          <DealerMake
                            make={make}
                            dealer={this.props.dealer}
                            updateDealerState={this.updateDealerState}
                            handleFieldChange={this.handleFieldChange}
                            working={this.props.working}
                          />
                        </div>
                      );
                    })}
                  </div>
                </div>
              </div>
              {/* // CARS */}

              <div role="tabpanel" className="tab-pane" id="delivery">
                <div className="row">
                  <div className="col-xs-12 col-md-6">
                    <h3 style={{marginTop: '0px'}}>Biler på lager</h3>
                    <p className="text-info" style={{marginBottom: '15px'}}>Her registreres info om leveringstid for <strong>biler på lager i Drammen.</strong></p>

                    <div className="form-group">
                      <label>Leveringstid - kort beskrivelse</label>
                      <input type="text" className="form-control" name="deliveryShortDescription" defaultValue={dealer.deliveryShortDescription} disabled={this.props.working} onChange={this.handleFieldChange} />
                      <span className="help-block">Brukes primært for biler på lager. Kort info om leveringstid. Feks: &quot;2-3 uker&quot;</span>
                    </div>

                    <div className="form-group">
                      <label>Leveringstid - lang beskrivelse</label>
                      <textarea className="form-control" name="deliveryLongDescription" rows="15" defaultValue={dealer.deliveryLongDescription} disabled={this.props.working} onChange={this.handleFieldChange} />
                      <span className="help-block">Brukes primært for biler på lager. Mer utfyllende tekst om leveringstid, vises i konfigurator.</span>
                    </div>
                  </div>
                </div>
              </div>

              {/* SETTINGS */}
              <div role="tabpanel" className="tab-pane" id="settings">
                <div className="row">
                  <div className="col-xs-12">
                    <div className="form-group">
                      <label>Tags <em className="small text-muted">Grupper forhandlerer skal tilknyttes. F.eks &quot;sulland&quot; eller &quot;motorforum&quot;.</em></label>
                      <TagsInput
                        addOnBlur={true}
                        value={dealer.groupTags}
                        onChange={this.handleGroupTagsChange}
                        className="react-tagsinput form-control"
                        addKeys={[9, 13, 188]}
                        inputProps={{placeholder: 'Legg til'}}
                      />
                      <div className="mf-margin-top-10">
                        {this.props.tags && this.props.tags.map((tag, i) => {
                          return <span key={i}><a onClick={(e) => this.handleGroupTagClick(e, tag)} className="label label-primary">{tag}</a> </span>;
                        })}
                      </div>
                    </div>
                  </div>
                </div>

                <div className="row mf-margin-top-20">
                  <div className="col-xs-12">
                    <div className="checkbox">
                      <label>
                        <input type="checkbox" name="skipBuild" defaultChecked={dealer.skipBuild} disabled={this.props.working} onChange={this.handleFieldChange} />
                        Ikke bygg sider
                      </label>
                      <span id="helpBlockSkipBuild" className="help-block">Brukes dersom forhandleren skal være publisert, men man ikke ønsker å bygge sider for denne.</span>
                    </div>
                  </div>
                  <div className="col-xs-12">
                    <div className="checkbox">
                      <label>
                        <input type="checkbox" name="availableOnMinSide" defaultChecked={dealer.availableOnMinSide} disabled={!dealer.skipBuild || this.props.working} onChange={this.handleFieldChange} />
                        Tilgjengelig på MinSide
                      </label>
                      <span id="helpBlockavailableOnMinSide" className="help-block">Gjør forhandleren tilgjengelig via MinSide selv om den ikke bygges.</span>
                    </div>
                  </div>

                  <div className="col-xs-12 col-md-6 mf-margin-top-10">
                    <fieldset>
                      <legend>Online booking</legend>
                      <label>Aktiver OLB for denne forhandleren</label>
                      <div className="checkbox">
                        <label>
                          <input type="checkbox" name="onlineBookingMitsubishi" defaultChecked={dealer.onlineBookingMitsubishi} disabled={this.props.working} onChange={this.handleFieldChange} />
                          Online Booking Mitsubishi
                        </label>
                      </div>
                      <div className="checkbox">
                        <label>
                          <input type="checkbox" name="onlineBookingHongqi" defaultChecked={dealer.onlineBookingHongqi} disabled={this.props.working} onChange={this.handleFieldChange} />
                          Online Booking Hongqi
                        </label>
                      </div>
                    </fieldset>
                  </div>

                  <div className="col-xs-12 col-md-6 mf-margin-top-10">
                    <fieldset>
                      <legend>Nordea innstillinger</legend>
                      <div className="checkbox">
                        <label>
                          <input type="checkbox" name="nordea" defaultChecked={dealer.nordea} disabled={(!dealer.nordeaBranchId || !dealer.nordeaVendorId) || this.props.working} onChange={this.handleFieldChange} />
                         Aktiver Nordea lånewidget
                        </label>
                      </div>

                      <div className="form-group">
                        <label>BranchID <em className="small text-muted">Forhandlerens BranchID i Nordea sitt system</em></label>
                        <input type="text" className="form-control" disabled={this.props.working} name="nordeaBranchId" defaultValue={dealer.nordeaBranchId} onChange={this.handleFieldChange}/>
                      </div>
                      <div className="form-group">
                        <label>VendorID <em className="small text-muted">Forhandlerens VendorID i Nordea sitt system</em></label>
                        <input type="text" className="form-control" disabled={this.props.working} name="nordeaVendorId" defaultValue={dealer.nordeaVendorId} onChange={this.handleFieldChange}/>
                      </div>
                    </fieldset>
                  </div>

                  <div className="col-xs-12 col-md-6 mf-margin-top-20">
                    <fieldset>
                      <legend>Google Analytics</legend>
                      <div className="form-group">
                        <label>Google Analytics <br/><em className="small text-muted">Standard GA-kode. Brukes dersom det ikke er satt noen merkespesifik GA-kode under</em></label>
                        <input type="text" className="form-control" name="googleAnalyticsId" defaultValue={dealer.googleAnalyticsId} disabled={this.props.working} onChange={this.handleFieldChange} />
                      </div>

                      <div className={(makeNames.indexOf('mitsubishi') === -1) ? 'hidden' : ''}>
                        <div className="form-group">
                          <label>Google Analytics Misubishi <em className="small text-muted">GA-kode spesifikt for Mitsubishi</em></label>
                          <input type="text" className="form-control" name="googleAnalyticsIdMitsubishi" defaultValue={dealer.googleAnalyticsIdMitsubishi} disabled={this.props.working} onChange={this.handleFieldChange} />
                        </div>
                      </div>
                    </fieldset>
                  </div>

                  <div className="col-xs-12 col-md-6 mf-margin-top-20">
                    <fieldset>
                      <legend>Annet</legend>
                      <div className="form-group">
                        <label>Finn.no OrgId <br/><em className="small text-muted">(OrgId fra finn.no. Dersom denne finnes vises iframe med bruktbiler fra finn.no)</em></label>
                        <input type="text" className="form-control" disabled={this.props.working} name="finnOrgId" defaultValue={dealer.finnOrgId} onChange={this.handleFieldChange}/>
                      </div>

                      <div className="form-group">
                        <label>Unik kode (prefiks) <em className="small text-muted">(Påkrevet, denne bør ikke endres)</em></label>
                        <input type="text" className="form-control" disabled={this.props.working} name="slug" defaultValue={dealer.slug} onChange={this.handleFieldChange} required/>
                      </div>

                      <div className="form-group">
                        <label>AX-referanse <em className="small text-muted">Brukes f.eks på min side, må matche id i Axapta.</em></label>
                        <input type="text" className="form-control" disabled={this.props.working} name="externalRef" defaultValue={dealer.externalRef} onChange={this.handleFieldChange}/>
                      </div>

                      <div className="form-group">
                        <label>AD-navn <br/><em className="small text-muted">Settes om forhandleren har et annet navn i AD en på nettsidene. Brukes i import av ansatte</em></label>
                        <input type="text" className="form-control" disabled={this.props.working} name="firmSyncName" defaultValue={dealer.firmSyncName} onChange={this.handleFieldChange}/>
                        <span className="help-block">Etter å ha lagret nytt AD-navn må du oppdatere Admin for å sjekke det nye navnet</span>
                      </div>
                    </fieldset>
                  </div>
                </div>
              </div>
              {/* // SETTINGS */}

              {/* CONSULTING */}
              <div role="tabpanel" className="tab-pane" id="consulting">
                <div className="row">
                  <div className="col-xs-12 col-md-6">
                    <h3 style={{marginTop: '0px'}}>Digital konsultasjon</h3>
                    <p className="text-info" style={{marginBottom: '15px'}}>Her blir digital konsultasjon aktivert og tilpasset</p>

                    <div className="checkbox mf-margin-bottom-20">
                      <label>
                        <input type="checkbox" name="digitalConsultingEnabled" defaultChecked={dealer.digitalConsultingEnabled} disabled={this.props.working} onChange={this.handleFieldChange} />
                        Aktiver digital konsultasjon for denne forhandleren
                      </label>
                    </div>

                    {dealer.digitalConsultingEnabled && <div>
                      <h3 className="mf-margin-bottom-20">Tilgjengelige platformer</h3>

                      <div className="checkbox">
                        <label>
                          <input type="checkbox" name="digitalConsultingFreetext" defaultChecked={dealer.digitalConsultingFreetext} disabled={this.props.working} onChange={this.handleFieldChange} />
                          Tillatt fritt platformvalg (fritekst felt)
                        </label>
                      </div>

                      <div className="form-group">
                        <CustomVariables
                          variables={dealer.digitalConsultingPlatforms}
                          name="digitalConsultingPlatforms"
                          onSave={this.handleFieldChange}
                          valueFormat={(v) => v}
                          indexed={true}
                        />
                      </div>
                    </div>}
                  </div>
                </div>
              </div>
              {/* // CONSULTING */}


            </div> {/* // Tab content */}
          </form>
        </section>
      );
    }
  }
}

Dealer.defaultProps = {
  dealer: null,
  employees: [],
  modified: null,
  working: null,
  onChange: () => {},
  onSave: () => {},
  onPublish: () => {},
  onUnpublish: () => {},
  updateDealerState: () => {},
  handleMakesModelPanel: () => {},
  handleEmployeePanel: () => {}
};

export default Dealer;
